import React from 'react';
import { motion } from 'framer-motion';
export function WhyWorksSection() {
  return <section className="py-24" data-id="element-164">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-166">
          <h2 className="text-3xl font-bold tracking-tight text-white md:text-4xl" data-id="element-167">
            Por qué esto funciona cuando lo demás falla
          </h2>
          <p className="mt-8 text-xl text-gray-300" data-id="element-168">
            Porque la mayoría consume contenido sobre el tema como
            entretenimiento (teoría).
          </p>
          <p className="mt-4 text-2xl font-bold text-amber-500" data-id="element-169">
            Tú necesitas un protocolo.
          </p>

          <div className="mt-12 grid gap-4 text-left sm:grid-cols-2" data-id="element-170">
            <div className="rounded-lg bg-[#1a1a1a] p-6" data-id="element-171">
              <p className="font-medium text-white" data-id="element-172">
                Reduce cambios impulsivos
              </p>
            </div>
            <div className="rounded-lg bg-[#1a1a1a] p-6" data-id="element-173">
              <p className="font-medium text-white" data-id="element-174">
                Te obliga a medir señales reales
              </p>
            </div>
            <div className="rounded-lg bg-[#1a1a1a] p-6" data-id="element-175">
              <p className="font-medium text-white" data-id="element-176">
                Te da comunicación limpia con soporte
              </p>
            </div>
            <div className="rounded-lg bg-[#1a1a1a] p-6" data-id="element-177">
              <p className="font-medium text-white" data-id="element-178">
                Te activa un Plan B para que no dependas del feed
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}